module.exports = __webpack_public_path__ + "img/napoli-logo-icon.883fdeb9.png";